export default "__VITE_ASSET__ChEnUYL1__"